import Event from '../../core/Event';
import Channel from '../../../domain/Channel';

export default class ChannelNodesReceived extends Event {
    public static type = 'ChannelNodesReceived';

    constructor(public readonly channels: Channel[]) {
        super(ChannelNodesReceived.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/ChannelNodesReceived.ts